import { Component, OnInit } from '@angular/core';
import { AssignmentService } from '../../assignment/core/assignment.service';
import { Assignment } from '../../assignment/shared/assignment';
import { FlagService } from '../../core/flag.service';
import { ngListService } from '../../list/core/ng-list.service';
import { ListQueryParams } from '../../list/shared/list-query-params';
import { LtiService } from '../../lti/core/lti.service';
import { LTIDeeplinkingService } from '../../lti/core/ltideeplinking.service';
import { FormType } from '../../rl-common/forms/shared/form-type.enum';
import { EntityType } from '../../rl-common/shared/shared/entity-type.enum';
import { Router } from '@angular/router';

@Component({
  selector: 'rl-assignment-quick-start',
  templateUrl: './assignment-quick-start.component.html',
  styleUrls: ['./assignment-quick-start.component.scss', './assignment-quick-start.component-rtl.css']
})
export class AssignmentQuickStartComponent implements OnInit {
  data = {
    type: FormType.ASSIGNMENT_NEW_WELCOME,
    entity: EntityType.ASSIGNMENT,
    onAdd: undefined
  };

  loadList: boolean;
  isListSelected: boolean;
  selectedListId: string;
  lists: any[];

  allowSelectAsgmt: boolean;
  activeView: 'SELECT' | 'CREATE' | '' = '';
  asgmts: Assignment[];
  busy: boolean;

  constructor(
    private flagService: FlagService,
    private assignmentService: AssignmentService,
    private listService: ngListService,
    private ltiService: LtiService,
    private ltiDpService: LTIDeeplinkingService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.handleExistingAssignments();
    this.loadLists();
    this.data.onAdd = (asgmt: Assignment) => {
      this.busy = true;

      this.linkAssignmentToLTI(asgmt.id);
    };
  }

  handleExistingAssignments() {
    this.allowSelectAsgmt = this.flagService.allowAssignmentsManagment();
    this.allowSelectAsgmt ? this.assignmentService.getAll({ attachToLMS: 'false' }).subscribe((asgmts) => (this.asgmts = asgmts)) : (this.activeView = 'CREATE');
  }

  loadLists() {
    let params = new ListQueryParams();
    params.orderBy = 'name';
    params.onlyAttachToLMS = true;
    this.listService.getAll(params).subscribe((lists) => {
      this.lists = lists;
      this.selectedListId = this.lists[0].id;
      if (this.lists.length == 1) {
        this.isListSelected = true;
        this.selectList();
      }
    });
  }

  linkAssignmentToLTI = (aId: string) => {
    if (this.flagService.isDeeplinkRequest()) {
      this.ltiDpService.link(EntityType.ASSIGNMENT, { id: aId });
    } else {
      this.router.navigate(['/assignments/' + aId]);
    }
  };

  toggleView = (val: 'SELECT' | 'CREATE') => (this.activeView = this.activeView == val ? '' : val);

  selectList() {
    this.loadList = true;
    this.listService.get(this.selectedListId).subscribe((l) => {
      this.loadList = false;
      this.isListSelected = true;
    });
  }

  isItOnlyOption = () => !this.allowSelectAsgmt;
}
